
// EIN validation - 9 digits, typically formatted as XX-XXXXXXX
export const isValidEIN = (ein: string): boolean => {
  // Remove any non-digit characters
  const cleanEIN = ein.replace(/[^0-9]/g, '');
  
  // Check if it's 9 digits
  return cleanEIN.length === 9;
};

// Format EIN for display as XX-XXXXXXX
export const formatEIN = (ein: string): string => {
  const cleanEIN = ein.replace(/[^0-9]/g, '');
  
  if (cleanEIN.length < 2) {
    return cleanEIN;
  }
  
  if (cleanEIN.length <= 9) {
    return `${cleanEIN.slice(0, 2)}-${cleanEIN.slice(2)}`;
  }
  
  return `${cleanEIN.slice(0, 2)}-${cleanEIN.slice(2, 9)}`;
};

// Email validation
export const isValidEmail = (email: string): boolean => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};
